import { popKeyword } from "../constants";
import myFetch from '../helpers/myFetch';


export function popKeyword_GetDay(sDate,eDate){
    return{
        type:popKeyword.GET_DAY,
        sDate:sDate,
        eDate:eDate,
    }
}

export function popKeyword_GetAmount(value){
    return{
        type:popKeyword.GET_AMOUNT,
        amount:value,
    }
}

export function fetchAllPopKeyword(source,type,sdate,edate){
    return dispatch => {
        dispatch(requestAllPopKeyword())
        return myFetch('', true, true)('v5/lowi3/s/pop_keywords', {glb_source:source,glb_type:type,sdate:sdate,edate:edate})
        .then(json => dispatch(receiveAllPopKeyword(json)))
        .catch(err => {console.log(err)})
      };
}

function requestAllPopKeyword(){
    return{
        type:popKeyword.REQUEST_POPKEYWORD,
        receivedAt: Date.now(),
    }
}

function receiveAllPopKeyword(json){
    return{
        type:popKeyword.RECEIVE_POPKEYWORD,
        chart:json.pop_keys,
        receivedAt: Date.now(),
    }
}


// WEBPACK FOOTER //
// ./src/actions/popKeyword.action.js